
/** 
* This file has been auto-generated by '@kontent-ai/model-generator@8.1.1'.
* 
* (c) Kontent.ai
*  
* -------------------------------------------------------------------------------
* 
* Project: UnumUK Employer Portal
* Environment: Dev (Previously Phase 2)
* Id: a5beabf7-cb3f-0126-9900-a0a631d69346
* 
* -------------------------------------------------------------------------------
**/

import type { Elements } from '@kontent-ai/delivery-sdk';
import type {
  ComponentColumnCard,
  NavInternalLink,
  NavExternalLink,
} from "./index.js";
import type { CoreContentType } from "../system/index.js";
import type { Products } from "../taxonomies/index.js";

/**
 * 🏗️ Component // Column Card Group
 *
 * Id: 741a44c4-376c-44a3-9c05-6d1d9e3bb8a3
 * Codename: column_card_group
 */
export type ComponentColumnCardGroup = CoreContentType<
    ComponentColumnCardGroupElementCodenames,
    {
        /**
         * Column Cards
         *
         * Type: modular_content
         * Required: true
         * Codename: column_cards
         * Id: fd1eaad6-96f7-4837-946d-8b2cd5571660
         */
        readonly column_cards: Elements.LinkedItemsElement<ComponentColumnCard>;
        /**
         * CTAs
         *
         * Type: modular_content
         * Required: false
         * Codename: ctas
         * Id: 4158ca11-4540-444f-9844-3e78301712b1
         */
        readonly ctas: Elements.LinkedItemsElement<NavInternalLink | NavExternalLink>;
        /**
         * Products
         *
         * Type: taxonomy
         * Required: false
         * Codename: products
         * Id: a5257859-bb1d-4262-8751-34d7e30742f4
         * Guidelines: • Restrict the visibility of this content to selected products. • If no products are selected, the content will be visible to all users.
         */
        readonly products: Elements.TaxonomyElement<Products, 'products'>;
    },
    'column_card_group'
>;

/**
 * Type representing all available element codenames for 🏗️ Component // Column Card Group
 */
export type ComponentColumnCardGroupElementCodenames = 'column_cards' | 'ctas' | 'products';

/**
 * Type guard for 🏗️ Component // Column Card Group
 *
 * Id: 741a44c4-376c-44a3-9c05-6d1d9e3bb8a3
 * Codename: column_card_group
 */
export function isComponentColumnCardGroup(item: CoreContentType | undefined | null): item is ComponentColumnCardGroup {
    return item?.system?.type === 'column_card_group';
}
